// Invoke `fetch`, automatically populating the X-CSRF-Token header, which is requised for non-GET requests
export function fetchWithCsrf(
  input: RequestInfo,
  init?: RequestInit | undefined,
): Promise<Response> {
  if (!init) return fetch(input);
  const { headers, ...initRest } = init;

  // A meta tag exists with the CSRF token in the content attribute
  const csrfElement = document.querySelector<HTMLMetaElement>(
    "[name='csrf-token']",
  );
  if (!csrfElement) return Promise.reject('CSRF token could not be found');

  return fetch(input, {
    headers: {
      'X-CSRF-Token': csrfElement.content,
      ...headers,
    },
    ...initRest,
  });
}

export default fetchWithCsrf;
